import { render, staticRenderFns } from "./DrivingLicenceBack.vue?vue&type=template&id=c87e9472&scoped=true"
var script = {}
import style0 from "./DrivingLicenceBack.vue?vue&type=style&index=0&id=c87e9472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87e9472",
  null
  
)

export default component.exports